export default "__VITE_ASSET__BWCWnA2l__"